module.exports = __webpack_public_path__ + "static/img/UL168-2.0d09881.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/detailpic/UL168/UL168-2.jpg
// module id = WvA7
// module chunks = 52